export default __webpack_public_path__ + "static/media/technical-design.c72a26bf.jpg";